module.exports = __webpack_public_path__ + "img/preview_pumpkin_clock.4ff122ca.png";